import { Divider } from 'cv-library-react-web';
import { themes } from 'cv-react-core';

// Get theme method
import getTheme from './Divider.theme';

// Get theme component method
const { themeComponent } = themes;

// Generate and export a themed component
export default themeComponent(Divider, getTheme);
